import { styled } from "../styles";
import { borders, compose, css, display, flexbox, grid, palette, positions, shadows, sizing, spacing, typography, } from "../system";
export var styleFunction = css(compose(borders, display, flexbox, grid, positions, palette, shadows, sizing, spacing, typography));
var BoxComponentName = "CosmosBox";
var Box = styled("div")(styleFunction, { name: BoxComponentName });
export { Box, BoxComponentName };
